import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import FormFieldRowWrapper from "ds/components/Form/Field/RowWrapper";
import FormField from "ds/components/Form/Field";
import Input from "ds/components/Input";
import FormArrayField from "ds/components/Form/ArrayField";

import FormFieldAccessibleProjectsTooltip from "./Tooltip";

type FormFieldValues = Record<"accessibleProjects", Record<"value", string>[]>;

const EMPTY_VALUE = { value: "" };

const FormFieldAccessibleProjects = () => {
  const {
    formState: { errors },
    register,
  } = useFormContext<FormFieldValues>();

  const handleOnKeyDown = useCallback(
    (callback?: () => void) => (e: React.KeyboardEvent) => {
      if (callback && e.key === "Enter") {
        callback();
      }
    },
    []
  );

  return (
    <FormArrayField<FormFieldValues, "accessibleProjects">
      name="accessibleProjects"
      addButtonLabel="Add another project"
      emptyValue={EMPTY_VALUE}
    >
      {({ field, index, addEmptyItem, suffix }) => (
        <FormField
          key={field.id}
          error={errors?.accessibleProjects?.[index]?.value?.message}
          label={index === 0 ? "Accessible projects" : undefined}
          isOptional
          tooltipInfoVariant="modal"
          tooltipInfo={<FormFieldAccessibleProjectsTooltip />}
          fullWidth
          noMargin
        >
          {({ ariaInputProps }) => (
            <FormFieldRowWrapper>
              <Input
                onKeyDown={handleOnKeyDown(addEmptyItem)}
                placeholder="Type project name here"
                error={!!errors?.accessibleProjects?.[index]?.value?.message}
                {...register(`accessibleProjects.${index}.value`)}
                {...ariaInputProps}
              />
              {suffix}
            </FormFieldRowWrapper>
          )}
        </FormField>
      )}
    </FormArrayField>
  );
};

export default FormFieldAccessibleProjects;
